module.exports = __webpack_public_path__ + "static/media/amberlu.d82f1fc2.jpeg";